module.exports = __webpack_public_path__ + "img/about-us-org.814e8c00.jpg";